import { Avatar, Card, Checkbox, Col, DatePicker, Form, Input, Row } from 'antd';
import ContractSelect from 'components/form/ContractSelect';
import moment from 'moment';
import WithOrgData from 'components/WithOrgData';
import { OrganizationSelect } from 'components/form/select/OrganizationSelect';
import { InputPhoneNumber } from 'components/form/InputPhoneNumber';
import { buildPobProfImgUrl } from 'components/quartermaster/util';
import defaultAvatarImg from 'img/default-avatar.png';

const formItemLayout = {
	labelCol: {
		xs: { span: 24 },
		sm: { span: 6 },
	},
	wrapperCol: {
		xs: { span: 24 },
		sm: { span: 18 },
	},
	style: {
		marginBottom: 0,
	},
};

const defaultMessage = 'This field is required';

export const PersonToPob = Form.create({
	onValuesChange: (props, changedValues, allValues) => {
		if (changedValues['lastKnownController']) {
			props.form.setFieldsValue({ contractID: '' });
		}
	},
})(
	WithOrgData(
		({
			form: { getFieldDecorator, getFieldValue, getFieldsValue },
			personData,
			pobNodeData,
			readonly,
			// credentials = {},
			orgData = {},
		}) => {

			let lastName = pobNodeData?.lastName || personData?.lastName;
			let firstName = pobNodeData?.firstName || personData?.firstName;
			let dob = personData?.dob && moment(personData.dob);
			let currentJobTitle = pobNodeData?.currentJobTitle;
			let onRigContactPhone = pobNodeData?.onRigContactPhone;
			let currentlyEssential = pobNodeData?.currentlyEssential;

			let customer = orgData.customer && {
				key: orgData.customer._id,
				label: orgData.customer.name,
			};
			let employer = pobNodeData?.employerID && {
				key: pobNodeData.employerID._id,
				label: pobNodeData.employerID.name,
			};
			if (!employer) {
				employer = personData?.employerID && {
					key: personData.employerID._id,
					label: personData.employerID.name,
				};
			}
			if (!employer) {
				employer = {
					key: null,
					label: null,
				};
			}

			let contract = pobNodeData?.contractID && {
				key: pobNodeData.contractID._id,
				label: pobNodeData.contractID.name,
			};

			if (!contract) {
				contract = {
					key: null,
					label: null,
				};
			}

			return (
				<Form style={{ height: '100%' }}>
					<Row type='flex' style={{ marginBottom: 12, flexDirection: 'column', height: '100%' }}>
						<Row type='flex' style={{ marginBottom: 12 }}>
							<Col style={{ width: 171, marginRight: 12 }}>
								<Card
									size='small'
									style={{ height: '100%' }}
									bodyStyle={{
										height: '100%',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										padding: 6,
									}}
								>
									<Avatar
										icon={<img onError={() => null} src={defaultAvatarImg} alt='' />}
										src={buildPobProfImgUrl(pobNodeData, 'orig')}
										size={171}
										shape='square'
										style={{ borderRadius: '2px' }}
									/>
								</Card>
							</Col>
							<Col style={{ flex: 1 }}>
								<Card size='small' title='Personal'>
									<Row gutter={12} type='flex'>
										<Col span={12}>
											<Form.Item label='Last Name' {...formItemLayout}>
												{getFieldDecorator('lastName', {
													initialValue: lastName,
													rules: [{ required: true, message: defaultMessage }],
												})(<Input disabled={personData ? true : false || readonly} size='small' />)}
											</Form.Item>
										</Col>
										<Col span={12}>
											<Form.Item label='First Name' {...formItemLayout}>
												{getFieldDecorator('firstName', {
													initialValue: firstName,
													rules: [{ required: true, message: defaultMessage }],
												})(<Input disabled={personData ? true : false || readonly} size='small' />)}
											</Form.Item>
										</Col>
									</Row>
									<Row gutter={12} type='flex'>
										<Col span={12}>
											<Form.Item label='Customer' {...formItemLayout}>
												{getFieldDecorator('customerID', {
													initialValue: customer,
													rules: [{ required: true, message: defaultMessage }],
												})(
													<OrganizationSelect
														disabled={true}
														classTypes={['flytsuite.customer']}
														labelInValue={true}
														size='small'
														allowClear
													/>,
												)}
											</Form.Item>
										</Col>
										<Col span={12}>
											<Form.Item label='Employer' {...formItemLayout}>
												{getFieldDecorator('employerID', {
													initialValue: employer,
													rules: [{ required: true, message: defaultMessage }],
												})(
													<OrganizationSelect
														classTypes={['flytsuite.employer']}
														labelInValue={true}
														size='small'
														allowClear
														disabled={readonly}
													/>,
												)}
											</Form.Item>
										</Col>
									</Row>
									<Row gutter={12} type='flex'>
										<Col span={12}>
											<Form.Item label='DOB' {...formItemLayout}>
												{getFieldDecorator('dob', {
													initialValue: dob,
													rules: [{ required: true, message: defaultMessage }],
												})(
													<DatePicker
														disabled={personData ? true : false || readonly}
														style={{ width: '100%' }}
														size='small'
														format='YYYY-MM-DD'
													/>,
												)}
											</Form.Item>
										</Col>
										<Col span={12}>
											<Form.Item label='Contract' {...formItemLayout}>
												{getFieldDecorator('contractID', {
													initialValue: contract,
												})(
													<ContractSelect
														orgType={'customer'}
														labelInValue
														size='small'
														allowClear
														// TODO: Fix this
														locationID={
															getFieldValue('lastKnownController') &&
															getFieldValue('lastKnownController').key
														}
														disabled={readonly}
													/>,
												)}
											</Form.Item>
										</Col>
									</Row>
								</Card>
							</Col>
						</Row>
						<Col style={{ flex: 1 }}>
							<Card size='small' title='POB Info' style={{ height: '100%' }}>
								<Row gutter={12} type='flex'>
									<Col span={12}>
										<Form.Item label='Job Title' {...formItemLayout}>
											{getFieldDecorator('currentJobTitle', {
												initialValue: currentJobTitle,
											})(<Input disabled={readonly} />)}
										</Form.Item>
									</Col>
									<Col span={12}>
										<Form.Item label='Supervisor Phone' {...formItemLayout}>
											{getFieldDecorator('onRigContactPhone', {
												initialValue: onRigContactPhone?.number,
											})(<InputPhoneNumber disabled={readonly} />)}
										</Form.Item>
									</Col>
								</Row>
								<Row gutter={12} type='flex'>
									<Col span={12}>
										<Form.Item label='Is Essential' {...formItemLayout}>
											{getFieldDecorator('currentlyEssential', {
												initialValue: currentlyEssential,
												valuePropName: 'checked',
											})(<Checkbox disabled={readonly} />)}
										</Form.Item>
									</Col>
								</Row>
							</Card>
						</Col>
					</Row>
				</Form>
			);
		},
	),
);

export const formatPersonToPobValues = (values) => {
	const {
		lastName,
		firstName,
		customerID,
		dob,
		employerID,
		lastKnownController,
		contractID,
		...restValues
	} = values;

	const formattedValues = {
		lastName: lastName.toUpperCase().trim(),
		firstName: firstName.toUpperCase().trim(),
		customerID: customerID && customerID.key,
		dob: moment(dob).format('YYYY-MM-DD'),
		employerID: employerID && employerID.key,
		contractID: contractID && contractID.key,
		lastKnownController: lastKnownController && lastKnownController.key,
		...restValues,
	};
	return formattedValues;
};
